/*                                                                                                                                                                                                                             */
var win = window;
win.o_global ||= {};
win.o_util ||= {};
var { o_global, o_util } = win;
/*        */
/*                                                                                                                                                                                                         */
var otto$1 = win.otto ?? {};
win.otto;
/*        */
/*                                                                                                                                                                                                        */
var asExport = /*                      */ (namespace, fieldKey, defaultValue) => namespace[fieldKey] ?? defaultValue;
/*        */
/*                  */
/**
 *
 */
var customerSession = /*           */ asExport(otto$1, "customerSession");
/**
 *
 *
 */
var onCustomerSessionRefresh = /*           */ asExport(customerSession, "onCustomerSessionRefresh");
/*        */
export { customerSession, onCustomerSessionRefresh };

/*                                     */